import React from 'react';

import Image from 'components/image';
import InstallButton from 'components/install-button';
import { htmlDecode } from 'utils';
import { TGame } from 'types';
import './styles.scss';

interface IGameInfo {
  game: TGame;
}

const GameInfo: React.FC<IGameInfo> = ({ game }) => {
  return (
    <div className="game-info-container flex justify-between mb2 p-side">
      <div className="flex items-center">
        <Image src={game.logoURL} />
        <div>
          <div className="name">{htmlDecode(game.name)}</div>
          {game.title && <div className="title">{htmlDecode(game.title)}</div>}
        </div>
      </div>
      <InstallButton gameId={game.id} trackClickURL={game.trackURL.click} />
    </div>
  );
};

export default GameInfo;
